//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../Routing/Routing.Corner.js";
let d=[[[0,"BendAttributeName",1,0],[0,"BendMethod",1,0],[0,"BendRadius",1,0],[0,"BendRatio",1,0],[0,"BendRatioToAttribute",1,0]],[[[],"GetSegment",{R_:{segment:"Routing.ISegment"}},0,0],[["num_side_segs"],"FindSideSegments",{R_:{side_segs:"Curve[]"}},0,0]],[]];
SPLM.Routing.BendCorner = class extends SPLM.Routing.Corner{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.BendCorner";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;